module.exports = __webpack_public_path__ + "static/media/img_nuestramadre.c8b58826.jpg";